import React from "react";
import { Link } from "react-router-dom";

const CHANNELS = {
  outreach: { name: "Journalist Outreach", tagline: "Earned coverage", path: "/services/journalist-outreach" },
  newswire: { name: "Newswire Distribution", tagline: "Broad syndication", path: "/services/newswire-distribution" },
  placements: { name: "Guaranteed Placements", tagline: "Named publications", path: "/services/guaranteed-placements" },
};

function ChannelCard({ channel, kind }) {
  const isPrimary = kind === "primary";
  return (
    <Link
      to={channel.path}
      className={`block rounded-[16px] p-5 border transition-all duration-200 ${
        isPrimary
          ? "bg-white/80 border-[#8b5cf6]/45 shadow-[0_8px_24px_rgba(109,40,217,0.12)] hover:shadow-[0_12px_32px_rgba(109,40,217,0.18)] hover:-translate-y-0.5"
          : "bg-white/60 border-[#e8e6ef] hover:border-[#d8d5e2] hover:bg-white/80"
      }`}
    >
      <span className={`block font-mono text-xs uppercase tracking-widest mb-2 ${isPrimary ? "text-[#6d28d9]" : "text-[#6b6880]"}`}>
        {isPrimary ? "START WITH" : "PAIR WITH"}
      </span>
      <span className="block text-[#14121c] text-[19px] font-semibold mb-1">{channel.name}</span>
      <span className="block text-[#3a3646] text-[15px]">{channel.tagline}</span>
    </Link>
  );
}

export default function RecommendationPanel({ goal }) {
  if (!goal) return null;
  const isCrisis = goal.primary === null;

  if (isCrisis) {
    return (
      <div className="max-w-xl">
        <div className="glass-card p-5">
          <span className="block font-mono text-xs uppercase tracking-widest text-[#6b6880] mb-2">
            OUR RECOMMENDATION
          </span>
          <span className="block text-[#14121c] text-[19px] font-semibold mb-1">Talk to our team first</span>
          <span className="block text-[#3a3646] text-[15px]">Judgement before distribution</span>
        </div>
        <p className="text-[#3a3646] text-[15.5px] leading-[1.7] mt-4">{goal.why}</p>
        <Link
          to="/contact"
          className="inline-flex items-center mt-5 bg-brand-gradient hover:opacity-90 text-white font-semibold px-6 py-[13px] rounded-[14px] text-[14px] transition-opacity"
          style={{ boxShadow: "0 8px 20px rgba(124,58,237,0.35)" }}
        >
          Talk to Our Team →
        </Link>
      </div>
    );
  }

  return (
    <>
      <span className="block font-mono text-xs uppercase tracking-widest text-[#6b6880] mb-4">
        OUR RECOMMENDATION
      </span>
      <div className={goal.combo ? "grid sm:grid-cols-2 gap-4" : "max-w-md"}>
        <ChannelCard channel={CHANNELS[goal.primary]} kind="primary" />
        {goal.combo && <ChannelCard channel={CHANNELS[goal.combo]} kind="combo" />}
      </div>
      <p className="text-[#3a3646] text-[15.5px] leading-[1.7] mt-4">{goal.why}</p>
      {goal.combo && (
        <div className="mt-5 pt-5 border-t border-[#ececf2]">
          <p className="text-[#3a3646] text-[15px]">
            Want this combination in one purchase?{" "}
            <Link to="/packages" className="text-[#7200CB] font-semibold hover:text-[#9b3ee8] transition-colors">
              See our curated packages →
            </Link>
          </p>
        </div>
      )}
    </>
  );
}